/* @sravni/react-design-system version 0.2.60 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { noop, useStyles } from '@sravni/react-utils';
import { Check } from '@sravni/react-icons';
import modules_6cfce947 from '../styles/Checkbox.module.less.js';

/**
 * @description The Checkbox component allows user to select multiple items from a list
 *
 * @component
 * @example
 * ```jsx
 * <Checkbox name="radio" value="default" label="Checkbox default" checked disabled />
 * ```
 */
var Checkbox = React.forwardRef(function (props, ref) {
    var name = props.name, value = props.value, checked = props.checked, disabled = props.disabled, className = props.className, children = props.children, readOnly = props.readOnly, _a = props.onChange, onChange = _a === void 0 ? noop : _a, restProps = __rest(props, ["name", "value", "checked", "disabled", "className", "children", "readOnly", "onChange"]);
    var cx = useStyles(modules_6cfce947);
    var classNames = cx(className, 'container', {
        checked: checked,
        disabled: disabled,
        readOnly: readOnly,
    });
    var controlClassNames = cx('control', {
        checked: checked,
        disabled: disabled,
    });
    return (React.createElement("label", { "data-qa": "Checkbox", className: classNames },
        React.createElement("input", __assign({ ref: ref, className: cx('input'), type: "checkbox", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange }, restProps)),
        React.createElement("div", { className: controlClassNames }, checked ? React.createElement(Check, { className: cx('icon') }) : null),
        children ? React.createElement("span", { className: cx('label') }, children) : null));
});
Checkbox.defaultProps = {
    checked: false,
};
Checkbox.displayName = 'Checkbox';

export default Checkbox;
//# sourceMappingURL=Checkbox.js.map
